import React from 'react';
import DistrictCourtCaseForm from './DistrictCourtCaseForm';

const OtherCourtEntry = () => {
    return (
        <div className='page-wrapper'>
            <DistrictCourtCaseForm courtLevel="other_court" title="অন্যান্য আদালত - কেস এন্ট্রি" court_type_no="0" />
        </div>
    );
};

export default OtherCourtEntry;


